import { toInteger } from 'lodash';

import { Question } from '../../services/exams/types';
import { numberToCharacter } from '../../utils/common/formatText';

export const getOptionsDataArray = (question: Question) => {
  const optionsDataArray = [];

  const optionsFrequency = question.analytics?.optionFrequency ?? {};

  const optionsKeys = Object.keys(optionsFrequency);

  // sum all the values in the optionsFrequency object
  const total = Object.values(optionsFrequency).reduce((a, b) => a + b);

  for (let i = 0; i < optionsKeys.length; i++) {
    optionsDataArray.push({
      name: numberToCharacter(toInteger(optionsKeys[i])),
      value: Math.round((optionsFrequency[optionsKeys[i]] / total) * 100),
      correct: question.mcqOpts?.answer === toInteger(optionsKeys[i]),
    });
  }
  return optionsDataArray;
};

export const getMarksDataArray = (question: Question) => {
  const marksDataArray = [];

  const marksFrequency = question.analytics?.markFrequency ?? {};

  const marksKeys = Object.keys(marksFrequency);

  // sum all the values in the optionsFrequency object
  const total = Object.values(marksFrequency).reduce((a, b) => a + b);

  for (let i = 0; i < marksKeys.length; i++) {
    marksDataArray.push({
      name: marksKeys[i],
      value: Math.round((marksFrequency[marksKeys[i]] / total) * 100),
    });
  }
  return marksDataArray;
};
